import React, { FC } from 'react'
import { Button, Icon } from '@wmgtech/legato'
import { cn } from 'shared/utils'

import { INavigationProps } from 'modules/ProjectEdit/components/Navigation/Navigation.props'
import 'modules/ProjectEdit/components/Navigation/Navigation.scss'

const Navigation: FC<INavigationProps> = ({ hidden, onGoBack, children }) => (
  <div
    className={cn('stepper-navigation', {
      'stepper-navigation--hidden': hidden
    })}
  >
    <Button
      onClick={onGoBack}
      containerStyle="outline"
      colorType="info"
      className="stepper-navigation__back-button"
      icon={<Icon name="arrow-left" className="stepper-navigation__back-button-icon" />}
    />
    <div>
      {children}
      <Button
        containerStyle="solid"
        htmlType="submit"
        colorType="secondary-black"
        className="stepper-navigation__next-button"
      >
        Save
      </Button>
    </div>
  </div>
)

export default Navigation
